import Collection from '../../utils/Collection';

import { CLEAR_STUDENT_DATA } from '../../actions/student';

import {
  FETCH_STUDENT_LESSONS_SENT,
  FETCH_STUDENT_LESSONS_SUCCEEDED,
  FETCH_STUDENT_LESSONS_FAILED,
} from '../../actions/lesson';

const initialState = {
  studentId: null,
  loading: false,
  loadingOne: false,
  lessons: [],
  numOfLessons: 0,
  page: 1,
};

export default function studentLessonReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case CLEAR_STUDENT_DATA:
      return initialState;
    case FETCH_STUDENT_LESSONS_SENT:
      return {
        ...state,
        loading: true,
        page: payload.page,
      };
    case FETCH_STUDENT_LESSONS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        lessons: Collection.reset(state.lessons, payload.lessons),
        numOfLessons: payload.numOfLessons,
      };
    case FETCH_STUDENT_LESSONS_FAILED:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
